import type { TOC } from '@ember/component/template-only'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import { pick } from 'teacher-ui-client/helpers/pick'
import InputText from 'teacher-ui-client/components/base/input-text'

interface Signature {
  Element: HTMLElement
  Args: {
    value?: string
    themeKey?: ThemeKeys
    updateValue(value: string): void
  }
}

export const InputSearch: TOC<Signature> = <template>
  <InputText
    data-test-input-search
    type="search"
    role="searchbox"
    value={{@value}}
    placeholder={{t "search"}}
    aria-label={{t "search"}}
    @themeKey={{@themeKey}}
    @icon="search"
    @iconEnd={{true}}
    {{on "input" (pick "target.value" @updateValue)}}
    ...attributes
  />
</template>

export default InputSearch
